"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsHandlerTypeString = void 0;
const DynamicColumnConfigProvider_1 = require("../components/DynamicColumnConfigProvider");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getColumnsHandlerTypeString(provider, params = {}, filterOptions) {
    return (0, DynamicColumnConfigProvider_1.defineColumnHandler)({
        name: provider.type,
        label: provider.label,
        columnType: 'string',
        arrayColumnType: 'string-array',
        filterOptions,
        format: (columnValue, data) => {
            var _a;
            if (columnValue) {
                return (_a = data.get(columnValue)) !== null && _a !== void 0 ? _a : columnValue;
            }
            else {
                return undefined;
            }
        },
        formatArray: (columnValue, data) => {
            return columnValue ? columnValue.map((value) => data.get(value)).join('; ') : undefined;
        },
        loadData: () => provider.getValues(params).then((resp) => resp.reduce((prev, current) => prev.set(current.value, current.label), new Map())),
    });
}
exports.getColumnsHandlerTypeString = getColumnsHandlerTypeString;
